var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recruit"},[_c('div',{staticClass:"top"}),_c('RecuruiLearn'),_c('div',{staticClass:"wrap"},[_c('RecuruiContact',{staticClass:"space1"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }